module.exports = __webpack_public_path__ + "static/media/eye-view.ac325313.svg";